/**
 * 💻 硬件并发数
 */
export default function deviceHardwareConcurrency(): number {
  return navigator.hardwareConcurrency;
}
